import useI18n from 'contexts/I18n/hook'
import { CardSizes } from 'core/card/enum'
import PopUp from 'core/pop-up'
import React from 'react'
import { translate } from '../utils'

type DeleteBuildModalProps = {
  buildName: string
  onCancel: () => void
  onConfirm: () => void
}

export default function DeleteBuildModal({ buildName, onCancel, onConfirm }: DeleteBuildModalProps) {
  const t = useI18n()

  return (
    <PopUp isActive size={CardSizes.MEDIUM}>
      <div className="bootstrap-modal">
        <h4 className="title is-4 bootstrap-modal-title">
          {translate(t, 'bootstrap.delete_build_title')}
        </h4>
        <p className="bootstrap-delete-message">
          <strong>{translate(t, 'bootstrap.deleting_file')}:</strong> {buildName}
        </p>
        <p className="bootstrap-delete-warning">
          {translate(t, 'bootstrap.delete_build_warning')}
        </p>
        <div className="bootstrap-modal-actions">
          <button type="button" className="button is-larger is-primary" onClick={onConfirm}>
            {translate(t, 'general.confirm')}
          </button>
          <button type="button" className="button is-larger" onClick={onCancel}>
            {translate(t, 'general.cancel')}
          </button>
        </div>
      </div>
    </PopUp>
  )
}
